import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Body } from '@cjdev-internal/visual-stack-x/Panel';
import {
  selectRiskIdentificationTableHeaders,
  selectRiskIdentificationTableData,
  selectShouldRenderRiskIdentificationTable,
  selectRiskIdentificationCaption,
  selectRiskIdentificationDateRange
} from '../../../reducer';
import { clearRiskIdentificationTable } from '../../../domain/ViolationDashboard/RiskIdentifications/actions';
import { useSearchParams } from 'react-router-dom';
import { getDimension } from './routeHelper';
import * as dimensionRedirectHelperFactory from './dimensionRedirectHelperFactory';
import { DataGrid } from "@cjdev-internal/visual-stack-x/DataGrid";
import {renderTrend} from "../../../domain/ViolationDashboard/RiskIdentifications/trend";
import  TopPanel from "./TopPanel";

export const RiskIdentificationTablePure = ({
  columns = [],
  data = [],
  caption,
  shouldRenderRiskIdentificationTable,
  dateRange,
}) => {
  const [searchParams] = useSearchParams();
  const dimension = getDimension(searchParams.toString());
  const dimensionRedirectHelper = useMemo(
    () => dimensionRedirectHelperFactory.create(dimension),
    [dimension]
  );

  const rowData = useMemo(() =>
    data.map((row, index) => {
      const rowObj = { id: index + 1 };
      columns.forEach((col, i) => {
        rowObj[col.label.replace(/\s+/g, '_')] = row[i];
      });
      return rowObj;
    }),
    [data, columns]
  );

  const columnDefs = useMemo(() =>
    columns.map((column) => {
      const fieldName = column.label.replace(/\s+/g, '_');
      const baseDef = {
        field: fieldName,
        headerName: column.label,
        suppressAutoSize: true,
        flex: 1,
        width: 150,
        minWidth: 100,
        resizable: true,
        headerTooltip: column.label,
      };
      // Only add cellRenderer for the trend column (e.g., Total Points Change)
      if (fieldName === 'Total_Points_Change' || fieldName === 'Total_Violations_Change') {
        return {
          ...baseDef,
          cellRenderer: (props) => renderTrend(parseInt(props.value)),
        };
      }
      return baseDef;
    }),
    [columns]
  );

  const TopPanelComponent = () => (
    <TopPanel
      caption={caption}
      dateRange={dateRange}
      dimensionRedirectHelper={dimensionRedirectHelper}
      dimension={dimension}
      data={data}
      columns={columns}
    />
  );

  if (!shouldRenderRiskIdentificationTable) return null;

  return (
    <Body data-testid="risk-identification-table">
      <div style={{ height: '590px' }}>
        <DataGrid
          title={caption}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination
          topPanel={TopPanelComponent}
          paginationSizes={[10, 25, 50]}
          paginationPageSize={10}
          getRowId={(dat) => dat.id}
        />
      </div>
    </Body>
  );
};

const mapStateToProps = state => ({
  columns: selectRiskIdentificationTableHeaders(state),
  data: selectRiskIdentificationTableData(state),
  shouldRenderRiskIdentificationTable: selectShouldRenderRiskIdentificationTable(state),
  caption: selectRiskIdentificationCaption(state),
  dateRange: selectRiskIdentificationDateRange(state)
});

const mapDispatchToProps = {
  clearRiskIdentificationTable
};
export default
connect(mapStateToProps, mapDispatchToProps)(RiskIdentificationTablePure)
;
